import '../App.css';

function Todo() {
  window.location.replace('https://play.google.com/store/apps/details?id=com.beautifulessentials.todo');

  return null;
}

export default Todo;
